"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/cardImage.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CardImage = function CardImage(_ref) {
  var _cardImageClasses;

  var children = _ref.children,
      className = _ref.className,
      img = _ref.img,
      borderRadius = _ref.borderRadius;
  var cardImageClasses = (_cardImageClasses = {
    'cardImage': true
  }, _defineProperty(_cardImageClasses, "cardImage-border-radius", borderRadius), _defineProperty(_cardImageClasses, _classnames.default, className), _cardImageClasses);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cardImageClasses)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cardImage-container"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: img,
    alt: ""
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "cardImage-text"
  }, children));
};

CardImage.propTypes = {
  children: _propTypes.default.element,
  className: _propTypes.default.string,
  borderRadius: _propTypes.default.bool,
  img: _propTypes.default.string
};
CardImage.defaultProps = {
  children: 'Insert a component or HTML tags',
  className: 'default',
  borderRadius: false,
  img: 'image'
};
var _default = CardImage;
exports.default = _default;